module.exports = __webpack_public_path__ + "static/media/fix1.299eccc1.jpg";